import PropTypes from 'prop-types';
import Alert from "components/ui/Alert/Alert";
import Loader from "components/ui/Loader/Loader";
import useComments from "hooks/useComments";
import CommentThread from "features/comments/components/CommentThread/CommentThread";
import Trans from "features/translation/components/Trans";

const Comments = ({ entity_id, bundle, refreshToken, onRefresh }) => {
  const { comments, isLoading, error } = useComments(entity_id, bundle, refreshToken);

  if (isLoading) {
    return <Loader/>;
  }

  if (!comments) {
    return <Alert message={ error }/>;
  }

  if (comments.length === 0) {
    return <Trans text={ `Er zijn nog geen reacties, bent u de eerste die reageert?` }/>;
  }

  return <CommentThread comments={ comments } onRefresh={ onRefresh }/>;
}

Comments.propTypes = {
  entity_id: PropTypes.number.isRequired,
  bundle: PropTypes.string.isRequired,
}

export default Comments;
